import { useMemo } from 'react'

import { useMyOrganizationMemberships } from 'src/hooks/use-my-organization-memberships'
import { useMyOrg } from 'src/layouts/AppStateContextLayout/utils'

/**
 * Builds the browser-tab title for a page.
 *
 * When the current user belongs to two or more organisations the active
 * org's city name is appended so tabs are easy to distinguish:
 *   "Email Templates | Springfield"
 *
 * The RedwoodProvider titleTemplate then adds "| GovWell" at the end:
 *   "Email Templates | Springfield | GovWell"
 */
export const usePageTitle = (baseTitle: string): string => {
  const organization = useMyOrg()
  const memberships = useMyOrganizationMemberships()

  return useMemo(() => {
    if (memberships.length >= 2 && organization?.city) {
      return `${baseTitle} | ${organization.city}`
    }
    return baseTitle
  }, [baseTitle, memberships.length, organization?.city])
}
